<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import Alert from 'src/components/cabinet/#common/alert/Alert.svelte'
    import Modal from 'src/components/cabinet/#common/modal/Modal.svelte'
    import {Link} from 'svelte-routing'
    import Transactions from 'src/components/cabinet/#common/transactions/Transactions.svelte'
    import IconifyIcon from '@iconify/svelte'
    import copyIcon from '@iconify/icons-fa-solid/copy'
    import {
        copyClipboard,
        delay,
        numberWithSpaces,
        abbreviateNumber,
        arrayToEnum
    } from 'src/components/cabinet/#common/helpers'
    import {myBalance} from "src/components/cabinet/#services/myBalance"
    import {
        checkMyTransactionForCurrency,
        getTestnetLis,
        myTransactionsToday
    } from 'src/components/cabinet/#services/myTransactions'
    import {getMyWallet, buyWallet} from 'src/components/cabinet/#services/nearAdapter'
    import buyIcon from './buy.svg'
    import arrowsIcon from './arrows.svg'
    import transferIcon from './transfer.svg'
    import cardIcon from './card.svg'
    import gameIcon from './game.svg'
    import infoIcon from './info.svg'
    import lisIcon from './lis.svg'
    import lockIcon from './lock.svg'
    import nearIcon from './near.svg'
    import usdtIcon from './usdt.svg'
    import maticIcon from './matic.svg'
    import dogecoinIcon from './dogecoin.svg'
    import pepeIcon from './pepe.svg'
    import nftIcon from './nft.svg'
    import rightIcon from './right.svg'
    import {getAllActiveMemberships} from "src/components/cabinet/#services/memberships"
    import silverIcon from '../../../../materials/images/memberships/silver.svg'
    import goldIcon from '../../../../materials/images/memberships/gold.svg'
    import platinumIcon from '../../../../materials/images/memberships/platinum.svg'
    import dragonsIcon from 'src/components/#assets/dragons.jpg'
    import catsIcon from 'src/components/#assets/cats.jpg'
    import foxesIcon from 'src/components/#assets/foxes.jpg'
    import dogesIcon from 'src/components/#assets/doge.jpg'
    import elonIcon from 'src/components/#assets/elon.jpg'
    import cryptoPepeIcon from 'src/components/#assets/pepe.jpg'
    import addMembershipIcon from 'src/components/cabinet/account/add-icon.svg'
    import QrCode from 'svelte-qrcode'
    import {roundNumber} from 'src/components/#common/helpers/helpers'
    import {showAlert} from 'src/components/#common/alert/store'
    import {getStakingBalance} from 'src/components/cabinet/#services/staking'
    import Transfer from 'src/components/cabinet/account/components/Transfer/Transfer.svelte'
    import Ramp from './components/Ramp/Ramp.svelte'
    import {getSettingOption} from 'src/components/cabinet/#services/settingsOption'
    import {getMyEthWallet} from 'src/components/cabinet/#services/evmAdapter'
    import Network from 'src/components/cabinet/account/components/Network/Network.svelte'
    import introJs from 'intro.js'
    import 'intro.js/introjs.css'
    import {onDestroy, onMount} from 'svelte'

    let loading = false
    let transferToggle
    let buyModalOpen = false
    let depositModalOpen = false
    let transferModalOpen = false
    let outerWidth
    let perPage = 5
    let selectedCurrency
    let selectedNetwork = 'Polygon'
    let modalWindowStatus = false
    let transferFrom = 'WLIS'
    let transferTo = 'LIS'
    let walletAddress
    const membershipIcons = { 'silver': silverIcon, 'gold': goldIcon, 'platinum': platinumIcon }
    let mobile = false
    let onMountIntro = false

    getMyWallet.send()
    getMyEthWallet.send()
    getStakingBalance.send()

    //checkMyTransactionForCurrency.reset()
    //checkMyTransactionForCurrency.send({ data: { currency: 'TLIS', reason: "nearTestnet" }})
    $: myTransactionsToday.send({ data: { page: 1, perPage } })
    getSettingOption.request({ data: { clientKey: 'cryptoMarket.rateByTokens' } })

    $: modalWindowStatus, modalWindowStatus !== true ? buyModalOpen = modalWindowStatus : false

    async function initIntroJs() {
        onMountIntro = true
        setTimeout(() => {
            introJs().setOptions({
                dontShowAgain: true,
                disableInteraction: true
            }).start()
        }, 100)
    }

    async function handleDataFetch() {
        await getAllActiveMemberships.request()
        if (!onMountIntro) {
            initIntroJs();
        }
    }

    async function buyWalletHandler() {
        try {
            loading = true
            await buyWallet.request()
            getMyWallet.reset()
            getMyWallet.send()

            selectedCurrency = undefined
            buyModalOpen = false

            showAlert.set({
                status: 'success',
                text: 'You have successfully purchased a Near deposit wallet'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            buyModalOpen = false
            depositModalOpen = false
            loading = false
        }
    }

    async function getTestnetLisHandler() {
        try {
            await getTestnetLis.request()

            showAlert.set({
                status: 'success',
                text: 'You have successfully received 100 LIS for testing'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            myBalance.send()
            //checkMyTransactionForCurrency.reset()
            //checkMyTransactionForCurrency.send({ data: { currency: 'TLIS', reason: "nearTestnet" }})
            myTransactionsToday.reset()
            myTransactionsToday.send({ data: { page: 1, perPage } })
        }
    }

    function getTotalBalancesUsd(balances, rates) {
        rates = JSON.parse(rates)
        if (Array.isArray(rates)) {
            rates = arrayToEnum(rates)
        }

        let sum: number = 0
        sum += (balances.BLIS + balances.LIS + balances.PLIS + balances.PWLIS + balances.WLIS) * rates.LIS
        sum += balances.NEAR * rates.NEAR
        sum += balances.USDT
        return numberWithSpaces(sum.toFixed(2))
    }

    async function copy(event, value) {
        let button = event.currentTarget
        button.setAttribute('data-tooltip', 'Copied')
        copyClipboard(value)
        await delay(2500)
        button.removeAttribute('data-tooltip')
    }

    $: outerWidth, buyModalOpen = false, modalWindowStatus = false

    function handleResize() {
        if (mobile != window.innerWidth < 768) {
            mobile = !mobile
            initIntroJs()
        }
    }

    onMount(() => {
        mobile = window.innerWidth < 768
        handleDataFetch()
        window.addEventListener('resize', handleResize)
    })

    onDestroy(() => {
        window.removeEventListener('resize', handleResize)
    })
</script>

<svelte:head>
    <title>Account</title>
</svelte:head>

<svelte:window bind:outerWidth />

<MainLayout>
    <svelte:fragment slot="content">
        <div class="cabinet-wrapper">
            <Alert />
            <div class="page-title">Account</div>
            <div class="row">
                <div class="col-lg-11 col-xl-10 col-xxl-6">
                    <div class="page-subtitle d-none d-md-block">Overview</div>
                    <div class="row big-balance-cards">
                        <div class="d-none d-md-block col-4">
                            <div class="balance-card" data-tooltip-class="introjs" data-title="Assets" data-intro="Manage your crypto assets" data-step="3">
                                <div class="balance-title">
                                    <!--<div class="balance-title-icon"><img src="{lisIcon}" alt=""></div>-->
                                    Wallet balance
                                </div>
                                <div class="balance-amount notranslate">
                                    {#if !$myBalance.hasValue}..{:else}
                                        {#if $myBalance.value.data.WLIS + $myBalance.value.data.PWLIS < 100000}
                                            {numberWithSpaces(Math.floor($myBalance.value.data.WLIS + $myBalance.value.data.PWLIS))} LIS
                                        {:else}
                                            {abbreviateNumber(Math.floor($myBalance.value.data.WLIS + $myBalance.value.data.PWLIS))} LIS
                                        {/if}
                                    {/if}
                                </div>
                                {#if $myBalance.hasValue && $myBalance.value.data.PWLIS > 0}
<!--                                    <div class="d-flex justify-content-center align-items-center">-->
<!--                                        <div class="purchased-amount notranslate"><img src="{lockIcon}" alt="">{roundNumber($myBalance.value.data.PWLIS)} LIS</div>-->
<!--                                        <div class="purchased-tooltip">-->
<!--                                            <img src="{infoIcon}" class="purchased-icon" alt="">-->
<!--                                            <div class="tooltip">For shopping only. After 7 days, the funds will be transferred to your main balance</div>-->
<!--                                        </div>-->
<!--                                    </div>-->
                                {/if}
                                <div class="balance-actions notranslate">
                                    {#if $myBalance.hasValue && ($myBalance.value.data.LIS > 0 || $myBalance.value.data.PLIS > 0 || $myBalance.value.data.WLIS > 0 || $myBalance.value.data.PWLIS > 0)}
                                        <button class="balance-btn" on:click={() => {
                                            transferFrom = 'WLIS';
                                            transferTo = 'LIS';
                                            transferModalOpen = true
                                        }}>
                                            <div><img src="{transferIcon}" alt=""></div>Transfer
                                        </button>
                                    {/if}
                                    <button class="balance-btn" on:click={() => {selectedNetwork = 'Near'; selectedCurrency = 'LIS'; depositModalOpen = true}} disabled={!$getMyWallet.hasValue}>
                                        <div><img src="{arrowsIcon}" alt=""></div>Deposit
                                    </button>
                                    {#if $myBalance.hasValue && ($myBalance.value.data.LIS > 0 || $myBalance.value.data.PLIS > 0 || $myBalance.value.data.WLIS > 0 || $myBalance.value.data.PWLIS > 0)}
                                        <Link to="swap" class="balance-btn">
                                            <div><img src="{transferIcon}" class="icon-90-rotate" alt=""></div>Swap
                                        </Link>
                                    {/if}
                                </div>
                            </div>
                        </div>
                        <div class="d-none d-md-block col-4">
                            <div class="balance-card">
                                <div class="balance-title">
                                    <!--<div class="balance-title-icon"><img src="{lisIcon}" alt=""></div>-->
                                    Game balance
                                </div>
                                <div class="balance-amount notranslate">
                                    {#if !$myBalance.hasValue}..{:else}
                                        {#if $myBalance.value.data.LIS + $myBalance.value.data.PLIS + $myBalance.value.data.BLIS < 100000}
                                            {numberWithSpaces(Math.floor($myBalance.value.data.LIS + $myBalance.value.data.PLIS + $myBalance.value.data.BLIS))} LIS
                                        {:else}
                                            {abbreviateNumber(Math.floor($myBalance.value.data.LIS + $myBalance.value.data.PLIS + $myBalance.value.data.BLIS))} LIS
                                        {/if}
                                    {/if}
                                </div>
                                <div class="in-game-purchases">In-game purchases only</div>
                                <div class="balance-actions notranslate"></div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <Link to="inventory" class="balance-card-link">
                                <div class="balance-card inventory-card">
                                    <div class="balance-title">Your Inventory</div>
                                    <div class="d-none d-md-block nft-icon"><img src="{nftIcon}" alt="nft"></div>
                                    <div class="view-all-btn"><span>View all</span> <img src="{rightIcon}" alt=""></div>
                                </div>
                            </Link>
                        </div>
                    </div>
                    {#if !mobile}
                        <div class="row mini-balance-cards d-none d-md-flex">
                            <div class="d-none col-4 d-md-block">
                                <div class="balance-card">
                                    <div class="balance-title notranslate">
                                        <div class="balance-title-icon"><img src="{usdtIcon}" alt=""></div>USDT
                                    </div>
                                    <div class="balance-amount notranslate">{!$myBalance.hasValue ? ".." : numberWithSpaces(Math.floor($myBalance.value.data.USDT))} USDT</div>
                                    <div class="balance-actions notranslate">
                                        <button class="balance-btn" on:click={() => {selectedNetwork = 'Polygon'; selectedCurrency = 'USDT'; depositModalOpen = true}} disabled={!$getMyWallet.hasValue}>
                                            <div><img src="{arrowsIcon}" alt=""></div>Deposit
                                        </button>
                                        <!--<button class="balance-btn" on:click={() => {
                                            transferFrom = 'USDT';
                                            transferTo = 'WUSDT';
                                            transferModalOpen = true
                                        }}>
                                            <div><img src="{transferIcon}" alt=""></div>Transfer
                                        </button>-->
                                        <Link to="withdrawal" class="balance-btn">
                                            <div><img src="{arrowsIcon}" class="icon-rotate" alt=""></div>Withdraw
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="balance-card">
                                    <div class="balance-title notranslate">
                                        <div class="balance-title-icon"><img src="{nearIcon}" alt=""></div>Near
                                    </div>
                                    <div class="balance-amount notranslate">{!$myBalance.hasValue ? ".." : numberWithSpaces(Math.floor($myBalance.value.data.NEAR))} NEAR</div>
                                    <div class="balance-actions notranslate">
                                        <button class="balance-btn" on:click={() => {
                                            selectedNetwork = 'Near';
                                            selectedCurrency = 'NEAR';
                                            depositModalOpen = true;
                                        }} disabled={!$getMyWallet.hasValue}>
                                            <div><img src="{arrowsIcon}" alt=""></div>Deposit
                                        </button>
                                        <Link to="swap" class="balance-btn">
                                            <div><img src="{transferIcon}" class="icon-90-rotate" alt=""></div>Swap
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="balance-card">
                                    <div class="balance-title notranslate">
                                        <div class="balance-title-icon"><img src="{maticIcon}" alt=""></div>Matic
                                    </div>
                                    <div class="balance-amount notranslate">{!$myBalance.hasValue ? ".." : numberWithSpaces(Math.floor($myBalance.value.data.MATIC))} MATIC</div>
                                    <div class="balance-actions notranslate">
                                        <button class="balance-btn" on:click={() => {
                                            selectedNetwork = 'Polygon';
                                            selectedCurrency = 'MATIC';
                                            depositModalOpen = true;
                                        }} disabled={!$getMyWallet.hasValue}>
                                            <div><img src="{arrowsIcon}" alt=""></div>Deposit
                                        </button>
                                        <Link to="swap" class="balance-btn">
                                            <div><img src="{transferIcon}" class="icon-90-rotate" alt=""></div>Swap
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mini-balance-cards d-none d-md-flex">
                            <div class="col-4">
                                <div class="balance-card">
                                    <div class="balance-title notranslate">
                                        <div class="balance-title-icon"><img src="{dogecoinIcon}" alt=""></div>Dogecoin
                                    </div>
                                    <div class="balance-amount notranslate">{!$myBalance.hasValue ? ".." :
                                        numberWithSpaces(Math.floor($myBalance.value.data.DOGE +
                                            $myBalance.value.data.WDOGE + $myBalance.value.data.PDOGE +
                                            $myBalance.value.data.PWDOGE + $myBalance.value.data.BDOGE))} DOGE</div>
                                    <div class="balance-actions notranslate">
                                        <button class="balance-btn" on:click={() => {
                                            transferFrom = 'DOGE';
                                            transferTo = 'WDOGE';
                                            transferModalOpen = true
                                        }}>
                                            <div><img src="{transferIcon}" alt=""></div>Transfer
                                        </button>
                                        <Link to="swap" class="balance-btn">
                                            <div><img src="{transferIcon}" class="icon-90-rotate" alt=""></div>Swap
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="balance-card">
                                    <div class="balance-title notranslate">
                                        <div class="balance-title-icon"><img src="{pepeIcon}" alt=""></div>Pepe
                                    </div>
                                    <div class="balance-amount notranslate">{!$myBalance.hasValue ? ".." :
                                        numberWithSpaces(Math.floor($myBalance.value.data.PEPE +
                                            $myBalance.value.data.WPEPE + $myBalance.value.data.PPEPE +
                                            $myBalance.value.data.PWPEPE + $myBalance.value.data.BPEPE))} PEPE</div>
                                    <div class="balance-actions notranslate">
                                        <button class="balance-btn" on:click={() => {
                                            transferFrom = 'PEPE';
                                            transferTo = 'WPEPE';
                                            transferModalOpen = true
                                        }}>
                                            <div><img src="{transferIcon}" alt=""></div>Transfer
                                        </button>
                                        <Link to="swap" class="balance-btn">
                                            <div><img src="{transferIcon}" class="icon-90-rotate" alt=""></div>Swap
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    {:else if mobile}
                        <div class="mini-balance-cards d-md-none" data-tooltip-class="introjs" data-title="Assets" data-intro="Tap to manage your crypto assets" data-step="3">
                            <Link to="balance/lis" class="balance-card-link">
                                <div class="balance-card">
                                    <div class="balance-title">
                                        <div class="balance-title-icon"><img src="{lisIcon}" alt=""></div>LIS
                                    </div>
                                    <div class="balance-amount notranslate">{!$myBalance.hasValue ? ".." : numberWithSpaces(roundNumber($myBalance.value.data.LIS + $myBalance.value.data.PLIS + $myBalance.value.data.WLIS + $myBalance.value.data.PWLIS + $myBalance.value.data.BLIS))} LIS</div>
                                </div>
                            </Link>
                            <Link to="balance/usdt" class="balance-card-link">
                                <div class="balance-card">
                                    <div class="balance-title notranslate">
                                        <div class="balance-title-icon"><img src="{usdtIcon}" alt=""></div>USDT
                                    </div>
                                    <div class="balance-amount notranslate">{!$myBalance.hasValue ? ".." : numberWithSpaces(roundNumber($myBalance.value.data.USDT))} USDT</div>
                                </div>
                            </Link>
                            <Link to="balance/near" class="balance-card-link">
                                <div class="balance-card">
                                    <div class="balance-title notranslate">
                                        <div class="balance-title-icon"><img src="{nearIcon}" alt=""></div>Near
                                    </div>
                                    <div class="balance-amount notranslate">{!$myBalance.hasValue ? ".." : numberWithSpaces(roundNumber($myBalance.value.data.NEAR))} NEAR</div>
                                </div>
                            </Link>
                            <Link to="balance/matic" class="balance-card-link">
                                <div class="balance-card">
                                    <div class="balance-title notranslate">
                                        <div class="balance-title-icon"><img src="{maticIcon}" alt=""></div>Matic
                                    </div>
                                    <div class="balance-amount notranslate">{!$myBalance.hasValue ? ".." : numberWithSpaces(roundNumber($myBalance.value.data.MATIC))} MATIC</div>
                                </div>
                            </Link>
                            <Link to="balance/dogecoin" class="balance-card-link">
                                <div class="balance-card">
                                    <div class="balance-title notranslate">
                                        <div class="balance-title-icon"><img src="{dogecoinIcon}" alt=""></div>Dogecoin
                                    </div>
                                    <div class="balance-amount notranslate">{!$myBalance.hasValue ? ".." :
                                        numberWithSpaces(Math.floor($myBalance.value.data.DOGE +
                                        $myBalance.value.data.WDOGE + $myBalance.value.data.PDOGE +
                                        $myBalance.value.data.PWDOGE + $myBalance.value.data.BDOGE))} DOGE</div>
                                </div>
                            </Link>
                            <Link to="balance/pepe" class="balance-card-link">
                                <div class="balance-card">
                                    <div class="balance-title notranslate">
                                        <div class="balance-title-icon"><img src="{pepeIcon}" alt=""></div>Pepe
                                    </div>
                                    <div class="balance-amount notranslate">{!$myBalance.hasValue ? ".." :
                                        numberWithSpaces(Math.floor($myBalance.value.data.PEPE +
                                        $myBalance.value.data.WPEPE + $myBalance.value.data.PPEPE +
                                        $myBalance.value.data.PWPEPE + $myBalance.value.data.BPEPE))} PEPE</div>
                                </div>
                            </Link>
                            {#if $getStakingBalance.hasValue && $getStakingBalance.value?.isUserParticipate}
<!--                            <Link to="staking" class="balance-card-link">-->
<!--                                <div class="balance-card">-->
<!--                                    <div class="balance-title">-->
<!--                                        <div class="balance-title-icon"><img src="{lisIcon}" alt=""></div>Staking-->
<!--                                    </div>-->
<!--                                    <div class="balance-amount notranslate">-->
<!--                                        {#if !$getStakingBalance.hasValue || $getStakingBalance.loading}-->
<!--                                            .. LIS-->
<!--                                        {:else if $getStakingBalance.hasValue && $getStakingBalance.value?.isUserParticipate}-->
<!--                                            {numberWithSpaces(roundNumber(+$getStakingBalance.value?.stakingBalance?.amount))} LIS-->
<!--                                        {:else}-->
<!--                                            0 LIS-->
<!--                                        {/if}-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </Link>-->
                            {/if}
                        </div>
                    {/if}
                    <Transfer bind:transferModalOpen={transferModalOpen} transferFrom={transferFrom} transferTo={transferTo}/>
                    <hr>
                    <div class="page-subtitle">My memberships</div>
                    {#if !$getAllActiveMemberships.hasValue && $getAllActiveMemberships.loading}
                        <div class="row memberships-cols">
                            {#if outerWidth > 1500}
                                {#each {length: 3} as {}}
                                    <div class="col-4 empty-col">
                                        <div class="membership-card empty">
                                            <div class="membership-add">
                                                <img src="{addMembershipIcon}" alt="">
                                            </div>
                                        </div>
                                    </div>
                                {/each}
                            {:else}
                                {#each {length: 2} as {}}
                                    <div class="col-4 empty-col">
                                        <div class="membership-card empty">
                                            <div class="membership-add">
                                                <img src="{addMembershipIcon}" alt="">
                                            </div>
                                        </div>
                                    </div>
                                {/each}
                            {/if}
                        </div>
                        <div class="text-center">
                            <Link to="memberships" class="btn-secondary d-block all-memberships-btn">View all memberships</Link>
                        </div>
                    {:else if !$getAllActiveMemberships.hasValue && $getAllActiveMemberships.error }
                        Something went wrong. Try refreshing the page.
                    {:else if $getAllActiveMemberships.value}
                        {#if $getAllActiveMemberships.value.length > 0}
                            <div class="row memberships-cols">
                                {#each $getAllActiveMemberships.value as { appId, membership, endDate, duration, id }}
                                    <div class="col-4">
                                        <div class="membership-card">
                                            <div class="icon">
                                                <img src={membershipIcons[membership.name]} alt="">
                                            </div>
                                            <div class="name">{membership.name}</div>
                                            <div class="date-end">
                                                {#if endDate}
                                                    Left {Math.floor((new Date(endDate) - new Date()) / (1000 * 3600 * 24))} days
                                                {:else if duration}
                                                    Duration {Math.floor(new Date(+duration) / 24)} days
                                                {:else}
                                                    Active subscription
                                                {/if}
                                            </div>
                                            <hr>
                                            <div class="game">
                                                {#if appId === 3}
                                                    <div class="game-icon"><img src={catsIcon} alt=""></div>
                                                    Crypto Cats
                                                {:else if appId === 5 || appId === 6}
                                                    <div class="game-icon"><img src={dragonsIcon} alt=""></div>
                                                    Crypto Dragons
                                                {:else if appId === 7}
                                                    <div class="game-icon"><img src={foxesIcon} alt=""></div>
                                                    Crypto Fox
                                                {:else if appId === 11}
                                                    <div class="game-icon"><img src={dogesIcon} alt=""></div>
                                                    Crypto DOGE
                                                {:else if appId === 13}
                                                    <div class="game-icon"><img src={elonIcon} alt=""></div>
                                                    Elon Game
                                                {:else if appId === 15}
                                                    <div class="game-icon"><img src={cryptoPepeIcon} alt=""></div>
                                                    Crypto Frepe
                                                {/if}
                                            </div>
                                        </div>
                                    </div>
                                {/each}
                                {#if ($getAllActiveMemberships.value.length%3) > 0 && outerWidth > 1500}
                                    {#each {length: 3-($getAllActiveMemberships.value.length%3)} as {}}
                                        <div class="col-4 empty-col">
                                            <Link to="memberships" class="membership-card empty">
                                                <div class="membership-add">
                                                    <img src="{addMembershipIcon}" alt="">
                                                </div>
                                            </Link>
                                        </div>
                                    {/each}
                                {:else if ($getAllActiveMemberships.value.length%2) > 0 && outerWidth <= 1500}
                                    <div class="col-4 empty-col">
                                        <Link to="memberships" class="membership-card empty">
                                            <div class="membership-add">
                                                <img src="{addMembershipIcon}" alt="">
                                            </div>
                                        </Link>
                                    </div>
                                {/if}
                            </div>
                            <div class="text-center">
                                <Link to="memberships" class="btn-secondary d-block all-memberships-btn">View all memberships</Link>
                            </div>
                        {:else}
                            <div class="empty-memberships" data-tooltip-class="introjs" data-title="Memberships" data-intro="Get access to new daily quests, which allow you to get more $LIS" data-step="4">
                                <div class="title">You have a standard membership</div>
                                <div class="description">Upgrade your membership and earn more <span class="notranslate">LIS</span> tokens</div>
                                <Link to="memberships" class="first-membership">
                                    <div class="membership-add">
                                        <img src="{addMembershipIcon}" alt="">
                                    </div>
                                </Link>
                            </div>
                        {/if}
                    {/if}
                </div>
                <div class="col-1"><div class="wallet-vertical-line"></div></div>
                <div class="col-lg-11 col-xl-10 col-xxl-5 pl-8">
                    <div class="page-subtitle transactions-title">Recent transactions</div>
                    {#if $myTransactionsToday.loading}
                        <Transactions/>
                    {:else if $myTransactionsToday.error || !$myTransactionsToday.hasValue }
                        Something went wrong. Try refreshing the page.
                    {:else if $myTransactionsToday.hasValue}
                        <Transactions transactions={$myTransactionsToday.value.data}/>
                        {#if $myTransactionsToday.value.totalCount !== 0}
                            <div class="text-center">
                                <Link to="activity" class="btn-secondary d-inline-block all-activity-btn">View full activities</Link>
                            </div>
                        {/if}
                    {/if}
                </div>
            </div>
        </div>
        <Modal bind:visible={depositModalOpen}>
            <svelte:fragment slot="content">
                {#if $getMyWallet.loading || !$getMyWallet.hasValue || $getMyEthWallet.loading || !$getMyEthWallet.hasValue}
                    <div class="modal-custom__title">Loading...</div>
                    <div class="modal-custom__text text-center">Loading...</div>
                    <div class="modal-custom__footer">
                        <button class="btn btn-cancel" on:click={() => { depositModalOpen = false }}>Cancel</button>
                        <button class="btn btn-primary" disabled>Loading...</button>
                    </div>
                {:else if selectedNetwork === 'Near' && $getMyWallet.hasValue && !$getMyWallet.value}
                    <div class="modal-custom__title">Buy a deposit wallet</div>
                    <div class="modal-custom__text">
                        <Network bind:selectedNetwork {selectedCurrency}/>
                        A wallet address for <span class="notranslate">{selectedCurrency}</span> deposits costs 0.1 <span class="notranslate">USDT</span>.<br>
                    </div>
                    <div class="modal-custom__footer">
                        <button class="btn btn-cancel" on:click={() => { depositModalOpen = false }}>Cancel</button>
                        <button class="btn btn-primary" on:click={buyWalletHandler} class:loading={loading} disabled={loading}>Buy</button>
                    </div>
                {:else if selectedNetwork === 'Near' && $getMyWallet.hasValue && $getMyWallet.value}
                    <div class="modal-custom__title">Deposit {selectedCurrency}</div>
                    <div class="modal-custom__text">
                        {#if selectedCurrency === 'LIS'}
                            <div class="deposit-notice">
                                Your deposited $LIS will be available for swap to $LIS on Solana blockchain.
                            </div>
                        {/if}
                        <Network bind:selectedNetwork {selectedCurrency}/>
                        Send your <span class="notranslate">{selectedCurrency}</span> to the wallet address below:
                        <div class="wallet-actions">
                            <input class="form-control w-100" value="{$getMyWallet?.value}" readonly>
                            <button on:click={(e) => copy(e, $getMyWallet?.value) } class="btn btn-primary copy-btn">
                                <span><IconifyIcon icon="{copyIcon}"/></span>
                            </button>
                        </div>
                        <div class="text-center">
                            <QrCode value="{$getMyWallet?.value}" background="#ffffff" color="#27272F" size="200"/>
                        </div>
                    </div>
                    <div class="modal-custom__footer">
                        <button class="btn btn-cancel" on:click={() => { depositModalOpen = false }}>Close</button>
                    </div>
                {:else if selectedNetwork === 'Polygon' && $getMyEthWallet.hasValue}
                    <div class="modal-custom__title">Deposit {selectedCurrency}</div>
                    <div class="modal-custom__text">
                        <Network bind:selectedNetwork {selectedCurrency}/>
                        Send your <span class="notranslate">{selectedCurrency}</span> to the wallet address below:
                        <div class="wallet-actions">
                            <input class="form-control w-100" value="{$getMyEthWallet?.value}" readonly>
                            <button on:click={(e) => copy(e, $getMyEthWallet?.value) } class="btn btn-primary copy-btn">
                                <span><IconifyIcon icon="{copyIcon}"/></span>
                            </button>
                        </div>
                        <div class="text-center">
                            <QrCode value="{$getMyEthWallet?.value}" background="#ffffff" color="#27272F" size="200"/>
                        </div>
                    </div>
                    <div class="modal-custom__footer">
                        <button class="btn btn-cancel" on:click={() => { depositModalOpen = false }}>Close</button>
                    </div>
                {/if}
            </svelte:fragment>
        </Modal>
        <Modal bind:visible={buyModalOpen}>
            <svelte:fragment slot="content">
                {#if $getMyWallet.loading || $getMyEthWallet.loading}
                    <div class="modal-custom__title">Loading...</div>
                    <div class="modal-custom__text text-center">Loading...</div>
                    <div class="modal-custom__footer">
                        <button class="btn btn-cancel" on:click={() => { buyModalOpen = false }}>Cancel</button>
                        <button class="btn btn-primary" disabled>Loading...</button>
                    </div>
                {:else if $getMyWallet.hasValue && $getMyEthWallet.hasValue}
                    {#if !selectedCurrency}
                        <div class="modal-custom__title">Buy {selectedCurrency || 'Crypto'}</div>
                        <div class="modal-custom__text">
                            <div class="all-coin-list">
                                <div class="coin-item" on:click={() => {selectedCurrency = 'NEAR'; walletAddress = $getMyWallet.value}}>
                                    <div class="coin-icon"><img src="/images/tokens/NEAR.svg"></div><div>NEAR</div>
                                </div>
                                <div class="coin-item" on:click={() => {selectedCurrency = 'USDT'; walletAddress = $getMyEthWallet.value}}>
                                    <div class="coin-icon"><img src="/images/tokens/USDT.svg"></div><div>USDT</div>
                                </div>
                                <div class="coin-item" on:click={() => {selectedCurrency = 'MATIC'; walletAddress = $getMyEthWallet.value}}>
                                    <div class="coin-icon"><img src="/images/tokens/MATIC.svg"></div><div>MATIC</div>
                                </div>
                            </div>
                        </div>
                    {:else if $getMyWallet.hasValue && !$getMyWallet.value && selectedCurrency === 'NEAR' && !walletAddress}
                        <div class="modal-custom__title">Buy a deposit wallet</div>
                        <div class="modal-custom__text text-center">
                            A wallet address for buying <span class="notranslate">{selectedCurrency || 'NEAR'}</span> costs 0.1 <span class="notranslate">USDT</span>.<br>
                        </div>
                        <div class="modal-custom__footer">
                            <button class="btn btn-cancel" on:click={() => { buyModalOpen = false }}>Cancel</button>
                            <button class="btn btn-primary" on:click={buyWalletHandler} class:loading={loading} disabled={loading}><span>Buy</span></button>
                        </div>
                    {:else if $getMyWallet.hasValue && $getMyEthWallet.hasValue}
                        <div class="modal-custom__title">Buy {selectedCurrency || 'Crypto'}</div>
                        <div class="modal-custom__text">
                            <Ramp bind:modalWindowStatus walletAddress={walletAddress} currency={selectedCurrency}/>
                        </div>
                    {/if}
                {/if}
            </svelte:fragment>
        </Modal>
    </svelte:fragment>
</MainLayout>

<style>
    .deposit-notice {
        margin: 12px 0;
        font-size: 14px;
        background: rgba(244, 67, 54, 0.37);
        padding: 10px;
        border-radius: 6px;
    }

    :global(.introjs-tooltip.introjs) {
        background: #cad5e0;
        color:  #1B262C;
    }

    :global(.introjs-tooltip.introjs .introjs-arrow.top) {
        border-bottom-color: #cad5e0;
    }

    :global(.introjs-tooltip.introjs .introjs-arrow.bottom) {
        border-top-color: #cad5e0;
    }

    :global(.introjs-tooltip.introjs .introjs-arrow.left-bottom),
    :global(.introjs-tooltip.introjs .introjs-arrow.left) {
        border-right-color: #cad5e0;
    }

    :global(.introjs-tooltip.introjs .introjs-arrow.right-bottom),
    :global(.introjs-tooltip.introjs .introjs-arrow.right) {
        border-left-color: #cad5e0;
    }

    :global(.introjs-tooltip.introjs .introjs-button) {
        background: #ff5d1c;
        text-shadow: none;
        color: white;
        border: 0;
        border-radius: 6px;
        transition: .2s;
    }

    :global(.introjs-tooltip.introjs .introjs-button.introjs-prevbutton) {
        background: #61707f;
    }

    :global(.introjs-tooltip.introjs .introjs-button.introjs-prevbutton:hover) {
        background: #6f7e8d;
    }

    :global(.introjs-tooltip.introjs .introjs-button.introjs-prevbutton.introjs-disabled) {
        opacity: 0;
    }

    :global(.introjs-tooltip.introjs .introjs-button:hover) {
        background: #df5118;
    }

    :global(.introjs-tooltip.introjs .introjs-tooltipbuttons) {
        border-top: 1px solid #b1bdc9;
    }

    :global(.introjs-tooltip.introjs .introjs-dontShowAgain label) {
        background: transparent;
        color: #61707f;
        cursor: pointer;
    }

    :global(.introjs-tooltip.introjs .introjs-dontShowAgain input) {
        width: 14px;
        height: 14px;
        margin-top: 5px;
        margin-bottom: 0;
        vertical-align: top;
        cursor: pointer;
    }

    :global(.introjs-tooltip.introjs .introjs-bullets ul li a) {
        background: #8e9aa7;
    }

    :global(.introjs-tooltip.introjs .introjs-bullets ul li a.active) {
        background: #61707f;
    }

    :global(.introjs-helperLayer) {
        box-shadow: rgba(33, 33, 33, 0.8) 0px 0px 1px 2px, rgba(33, 33, 33, 0.8) 0px 0px 0px 5000px !important;
    }

    :global(.introjs-skipbutton) {
        display: none !important;
    }

    :global(.balance-card-link) {
        text-decoration: none;
    }

    .big-balance-cards,
    .mini-balance-cards {
        margin-bottom: 24px;
    }

    .balance-card {
        background: #26244D;
        border: 2px solid #494591;
        border-radius: 20px;
        padding: 15px;
        height: 100%;
        text-align: center;
        position: relative;
        min-height: 180px;
        transition: .2s;
    }

    :global(.balance-card-link:hover .balance-card) {
        background: #353064;
    }

    .balance-title {
        font-size: 15px;
        color: #CAD5E0;
        margin-bottom: 15px;
        display: flex;
        justify-content: center;
    }

    .big-balance-cards .balance-title {
        font-size: 18px;
        margin: 15px 0 20px;
    }

    .balance-title-icon {
        background: #494591;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 5px;
    }

    .balance-title-icon img {
        max-width: 16px;
    }

    .total-balance-lis {
        font-weight: 600;
        font-size: 50px;
        margin-bottom: 10px;
        margin-top: 25px;
        line-height: 1;
    }

    .total-balance-lis.no-purchase-total {
        margin-top: 45px;
    }

    .total-balance-usd {
        font-size: 20px;
        color: #9AADC1;
        font-weight: 300;
        margin-bottom: 14px;
    }

    .total-purchased-lis {
        background: #343168;
        line-height: 1;
        padding: 10px 15px;
        margin: 0 10px 0 30px;
        border-radius: 5px;
        font-size: 18px;
        color: #CAD5E0;
        font-weight: 300;
    }

    .total-purchased-lis img {
        vertical-align: top;
        margin-right: 6px;
        width: 12px;
        opacity: 0.8;
    }

    .nft-icon img {
        margin: 10px 0 25px -22px;
        width: 94px;
    }

    .view-all-btn {
        font-size: 16px;
        line-height: 20px;
        color: white;
    }

    .view-all-btn img {
        transition: .2s;
    }

    .balance-card:hover .view-all-btn img {
        margin-right: -4px;
        margin-left: 4px;
    }

    .balance-amount {
        font-size: 25px;
        color: white;
        font-weight: 600;
        margin-bottom: 7px;
        line-height: 1;
    }

    .purchased-amount {
        background: #343168;
        line-height: 1;
        padding: 7px;
        margin: 0 5px 0 20px;
        border-radius: 5px;
        font-size: 13px;
        color: #CAD5E0;
        font-weight: 300;
    }

    .purchased-amount img {
        vertical-align: top;
        margin-right: 4px;
        width: 9px;
        opacity: 0.8;
    }

    .purchased-icon {
        width: 15px;
        vertical-align: top;
        margin-top: 3px;
    }

    .big-balance-cards .purchased-icon {
        width: 20px;
        vertical-align: middle;
        margin-top: 0;
    }

    .wallet-actions {
        white-space: nowrap;
        display: flex;
        align-items: center;
        margin: 20px 0;
    }

    .balance-actions {
        margin-top: 15px;
        display: flex;
        justify-content: center;
        position: absolute;
        width: 100%;
        left: 0;
        right: 0;
        bottom: 15px;
    }

    .mini-balance-cards .balance-card {
        padding-bottom: 80px;
    }

    :global(.balance-btn) {
        background: transparent;
        margin: 0 10px;
        font-size: 12px;
        border: 0;
        padding: 0;
        color: white;
        text-decoration: none;
    }

    :global(.balance-btn[disabled]) {
        opacity: .5;
    }

    :global(.balance-btn:hover) {
        color: white;
    }

    :global(.balance-btn div) {
        background: #494591;
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto 5px;
        border-radius: 8px;
        transition: .2s;
    }

    .view-all-btn img {
        vertical-align: top;
        margin-top: 3px;
    }

    :global(.balance-btn:hover div) {
        background: #7262FF;
    }

    .icon-rotate {
        transform: rotate(180deg);
    }

    .icon-90-rotate {
        transform: rotate(90deg);
    }

    .purchased-tooltip .tooltip {
        opacity: 0;
        visibility: hidden;
        background: #61758a;
        font-size: 14px;
        color: white;
        line-height: 1.2;
        padding: 5px 10px;
        transform: translateX(-50%);
        margin-left: 10px;
        margin-top: 12px;
        min-width: 250px;
        text-align: center;
        border-radius: 3px;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
        transition: opacity .2s, margin .2s;
    }

    .purchased-tooltip .tooltip:after {
        content: "";
        position: absolute;
        border: 8px solid transparent;
        border-bottom: 8px solid #61758a;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2;
    }

    .purchased-tooltip:hover .tooltip {
        display: block;
        opacity: 1;
        visibility: visible;
        margin-top: 8px;
    }

    .wallet-actions .form-control {
        box-shadow: inset 0 0 0 2px #ccccd5;
        color: white;
        width: auto;
        padding: 12px 16px;
        max-width: 100%;
        overflow: hidden;
        display: inline-block;
        cursor: text;
    }

    .wallet-actions .btn.btn-primary.copy-btn {
        padding: 14px;
        vertical-align: top;
        margin: 0 0 0 10px;
        width: 48px;
        min-width: 48px;
        height: 48px;
        font-size: 16px;
    }

    .wallet-main-balance img {
        width: 40px;
        height: 40px;
        margin-right: 10px;
    }

    .wallet-lis-address span {
        opacity: 0.6;
        border-bottom: 1px solid white;
        font-size: 16px;
        line-height: 18px;
        font-weight: 300;
    }

    .cabinet-wrapper :global(.btn-secondary.all-activity-btn) {
        margin: 0;
    }

    .wallet-vertical-line {
        height: 100%;
        width: 2px;
        background: #343168;
        margin: 0 auto;
    }

    hr {
        margin: 30px 0;
        background: rgba(89, 89, 142, 0.3);
        opacity: 1;
    }

    .cabinet-wrapper :global(.membership-card) {
        background: #26244d;
        border: 2px solid #494591;
        border-radius: 10px;
        padding: 20px;
        margin-bottom: 20px;
        display: block;
    }

    .membership-card .icon {
        background: rgba(89, 89, 142, 0.3);
        border-radius: 9px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 80px;
        height: 80px;
        margin: 0 auto 10px;
    }

    .membership-card .icon img {
        width: 52px;
        height: 52px;
        box-shadow: 0 0 8px 1px rgba(255, 255, 255, 0.3);
        border-radius: 50%;
    }

    .membership-card .name {
        color: white;
        font-weight: 800;
        font-size: 24px;
        line-height: 1;
        text-transform: uppercase;
        text-align: center;
        margin-bottom: 5px;
    }

    .membership-card .date-end {
        font-weight: 300;
        font-size: 12px;
        line-height: 20px;
        text-align: center;
        color: #CAD5E0;
    }

    .membership-card hr {
        background: rgba(73, 69, 145, 0.8);
        opacity: 1;
        margin: 20px 0;
    }

    .membership-card .game {
        display: flex;
        align-items: center;
        color: #CAD5E0;
        font-weight: 500;
        font-size: 16px;
        line-height: 18px;
    }

    .membership-card .game-icon {
        margin-right: 10px;
    }

    .membership-card .game-icon img {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        border: 1px solid #cad5e0;
    }

    .cabinet-wrapper :global(.membership-card.empty) {
        height: calc(100% - 20px);
        display: flex;
        align-items: center;
        justify-content: center;
        background: #26244d;
        border: 2px dashed #494591;
        cursor: pointer;
    }

    .cabinet-wrapper :global(.membership-card.empty:hover) {
        border: 2px solid #494591;
    }

    .membership-add {
        background: rgba(89, 89, 142, 0.3);
        border-radius: 10px;
        padding: 40px 38px;
    }

    .empty-memberships {
        margin-bottom: 15px;
        text-align: center;
    }

    .empty-memberships .title {
        color: #61758A;
        font-weight: 500;
        font-size: 24px;
        line-height: 20px;
        margin: 50px 0 20px;
    }

    .empty-memberships .description {
        color: #61758A;
        font-weight: 300;
        font-size: 18px;
        line-height: 18px;
        margin: 20px 0 40px;
    }

    .empty-memberships .membership-add {
        padding: 0;
        width: 100px;
        margin: 0 auto;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: .2s;
    }

    .empty-memberships :global(.first-membership) {
        display: table;
        margin: 0 auto;
    }

    .empty-memberships .membership-add:hover {
        background: rgba(89, 89, 142, 0.2);
    }

    .wallet-buttons button[disabled] {
        opacity: 0.5;
    }

    .wallet-buttons button:hover {
        background: transparent;
        color: white;
    }

    :global(.btn-secondary.all-memberships-btn) {
        margin-right: 0 !important;
        margin-bottom: 30px;
    }

    .btn.buy-crypto-btn {
        padding: 10px 15px !important;
        font-size: 15px !important;
        margin-top: 12px;
    }

    .all-coin-list {
        display: flex;
        justify-content: center;
    }

    .coin-item {
        margin: 0 5px;
        padding: 15px;
        border-radius: 5px;
        width: 33%;
        text-align: center;
        border: 1px solid #828692;
        transition: .2s;
        cursor: pointer;
    }

    .coin-item:hover {
        background: #3b405e;
    }

    .coin-icon {
        background: white;
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        margin: 0 auto 10px;
    }

    .coin-icon img {
        width: 30px;
        height: 30px;
    }

    .in-game-purchases {
        margin: 0 10px;
        font-size: 14px;
        border: 0;
        padding: 0;
        color: #FF9800;
        text-decoration: none;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 50px;
        line-height: 1.3;
    }

    @media(max-width: 1800px) {
        .balance-amount {
            font-size: 20px;
        }

        .purchased-amount {
            margin-left: 0;
            font-size: 12px;
        }
    }

    @media(max-width: 1600px) {
        .balance-amount {
            font-size: 25px;
        }

        .wallet-vertical-line {
            display: none;
        }

        .transactions-title {
            border-top: 2px solid #343168;
            padding-top: 25px;
            margin-top: 30px;
        }

        :global(.btn-secondary.all-memberships-btn) {
            margin-bottom: 0;
        }
    }

    @media(min-width: 1400px) and (max-width: 1600px) {
        .col-xxl-6 {
            flex: 0 0 auto;
            width: 70%;
        }

        .col-xxl-5 {
            width: 70%;
        }
    }

    @media(max-width: 1500px) {
        .memberships-cols .col-4 {
            width: 50%;
        }
    }

    @media (max-width: 1199px) {
        .balance-btn {
            margin: 0 6px;
        }

        .total-balance-lis {
            font-size: 50px;
        }

        .balance-amount {
            font-size: 19px;
        }

        .big-balance-cards .balance-title {
            font-size: 16px;
        }
    }

    @media(max-width: 992px) {
        .wallet-buttons button {
            margin-right: 15px;
            padding: 12px 16px;
            font-size: 14px;
        }

        .wallet-buttons button:last-child {
            margin-right: 0;
        }

        .wallet-lis-address span {
            font-size: 14px;
            margin: 0 10px;
        }

        .cabinet-wrapper .membership-card {
            padding: 15px;
        }

        .membership-card .name {
            font-size: 16px;
        }

        .membership-card .date-end {
            line-height: 15px;
            min-height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .membership-card hr {
            margin: 10px 0 15px;
        }

        .membership-card .game {
            font-size: 13px;
        }

        .membership-card .game-icon img {
            width: 30px;
            height: 30px;
        }

        .membership-card .icon img {
            width: 40px;
            height: 40px;
        }

        .membership-card .icon {
            width: 70px;
            height: 70px;
        }

        .membership-add {
            padding: 22px 20px;
        }

        .membership-add img {
            width: 36px;
        }

        .empty-memberships .title {
            font-size: 20px;
            line-height: normal;
            margin: 40px 0 10px;
        }

        .empty-memberships .description {
            font-size: 16px;
            line-height: 18px;
            margin: 10px 0 40px;
        }
    }

    @media(max-width: 767px) {
        .big-balance-cards .balance-title {
            font-size: 12px;
            margin: 0 0 10px;
            line-height: 1;
        }

        .big-balance-cards .balance-card {
            height: auto;
            min-height: initial;
            padding-top: 20px;
            padding-bottom: 20px;
            margin-bottom: 10px;
        }

        .total-balance-lis {
            font-size: 30px;
            margin-bottom: 4px;
        }

        .total-balance-usd {
            font-size: 14px;
            margin-bottom: 0;
            line-height: 1;
        }

        .total-purchased-lis {
            padding: 5px 10px;
            margin: 14px 5px 0 20px;
            font-size: 12px;
        }

        .total-purchased-lis img {
            margin-right: 5px;
            width: 10px;
            margin-top: -1px;
        }

        .big-balance-cards .purchased-icon {
            width: 15px;
            vertical-align: top;
            margin-top: 12px;
        }

        .purchased-tooltip .tooltip {
            font-size: 12px;
            min-width: 200px;
            margin-left: 8px;
        }

        .inventory-card .balance-title {
            font-size: 15px;
            justify-content: flex-start;
            margin-bottom: 0;
        }

        .view-all-btn {
            position: absolute;
            right: 15px;
            top: 20px;
        }

        .view-all-btn span {
            display: none;
        }

        .view-all-btn img {
            margin-top: 0;
        }

        .balance-card:hover .view-all-btn img {
            margin: 0;
        }

        .big-balance-cards {
            position: relative;
        }

        .big-balance-cards:after {
            content: "";
            height: 2px;
            background: #343168;
            width: 100%;
            margin: 10px 12px 0;
        }

        .big-balance-cards {
            margin-bottom: 20px;
        }

        .mini-balance-cards .balance-card {
            height: auto;
            min-height: initial;
            padding: 15px;
            margin-bottom: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .mini-balance-cards .balance-amount {
            margin: 0;
            font-size: 15px;
        }

        .mini-balance-cards .balance-title {
            font-size: 15px;
            justify-content: flex-start;
            margin-bottom: 0;
            align-items: center;
        }

        .balance-title-icon {
            width: 25px;
            height: 25px;
            margin-right: 10px;
        }

        .cabinet-wrapper :global(.btn-secondary.all-activity-btn) {
            width: 100%;
        }

        .membership-card .game {
            min-height: 36px;
        }

        .transfer-toggle {
            top: -15px;
            right: 15px;
            width: 30px;
            height: 30px;
        }

        .total-balance-lis.no-purchase-total {
            margin-top: 25px;
        }
    }
</style>
